import * as React from 'react';
const SizeContext = React.createContext(undefined);
export const SizeContextProvider = ({ children, size }) => {
    const originSize = React.useContext(SizeContext);
    return React.createElement(SizeContext.Provider, { value: size || originSize }, children);
};
export default SizeContext;
